{
  "name": "parking-admin",
  "version": "2.1.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "cypress run",
    "test:open": "cypress open",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.25",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.25",
    "@angular/compiler": "^21.2.25",
    "@angular/core": "^21.2.25",
    "@angular/forms": "^21.2.25",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.25",
    "@angular/platform-browser-dynamic": "^21.2.25",
    "@angular/router": "^21.2.25",
    "@lkp/parking-sdk": "^20261022.1.0",
    "@ngxs/storage-plugin": "^21.0.0",
    "@ngxs/store": "^21.0.0",
    "dayjs": "^1.11.10",
    "echarts": "^6.1.0",
    "ngx-echarts": "^21.0.0",
    "rxjs": "~7.8.0",
    "rxjs-compat": "^6.6.7",
    "tslib": "^2.3.0",
    "zone.js": "^0.16.3"
  },
  "devDependencies": {
    "@angular/build": "~21.2.26",
    "@angular/cli": "~21.2.25",
    "@angular/compiler-cli": "^21.2.25",
    "@cypress/schematic": "^2.5.1",
    "@ngxs/devtools-plugin": "^21.0.0",
    "@types/node": "^26.6.4",
    "cypress": "latest",
    "typescript": "~5.9"
  },
  "optionalDependencies": {
    "@rollup/rollup-linux-x64-gnu": "*"
  },
  "overrides": {
    "ts-morph": {
      "@ts-morph/common": "0.25.0"
    }
  }
}
